import type { ReactNode } from "react";
import { useState } from "react";

type Position = "top" | "bottom" | "left" | "right";

type ToolTipProps = {
  text: string;
  position?: Position;
  children: ReactNode;
};

const positionClasses: Record<Position, string> = {
  top: "bottom-full left-1/2 -translate-x-1/2 mb-2",
  bottom: "top-full left-1/2 -translate-x-1/2 mt-2",
  left: "right-full top-1/2 -translate-y-1/2 mr-2",
  right: "left-full top-1/2 -translate-y-1/2 ml-2",
};

export const Tooltip = ({
  text,
  position = "top",
  children,
}: ToolTipProps) => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div
      className="relative inline-block"
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
    >
      {children}
      <div
        className={`absolute bg-neutral-800 text-white px-3 py-2 rounded text-sm whitespace-nowrap z-10 transition-opacity duration-200 ${positionClasses[position]}`}
        style={{
          opacity: isVisible ? 1 : 0,
          visibility: isVisible ? "visible" : "hidden",
        }}
      >
        {text}
      </div>
    </div>
  );
};